export const isIOS = {
    methods: {
        isIOS(height) {
            const ua = window.navigator.userAgent;
            const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
            const webkit = !!ua.match(/WebKit/i);
            const isIOS = iOS && webkit && !ua.match(/CriOS/i);
            return isIOS ? 'calc(84vh - ' + height + 'px)' :  'calc(89vh - ' + height + 'px)'
        }
    }
};
